import { render } from "./ChartHeadline.vue?vue&type=template&id=8c7a9222&scoped=true"
import script from "./ChartHeadline.vue?vue&type=script&lang=js"
export * from "./ChartHeadline.vue?vue&type=script&lang=js"

import "./ChartHeadline.vue?vue&type=style&index=0&id=8c7a9222&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7a9222"]])

export default __exports__